import type { IconData } from '@stacksjs/iconify-core'

export const yinYangSymbolRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M29.718 5.352A19.5 19.5 0 0 0 24 4.5C13.23 4.5 4.5 13.23 4.5 24c0 7.044 3.735 13.216 9.332 16.643a11.7 11.7 0 0 1-1.582-5.892C12.25 28.26 17.51 23 24 23c5.385 0 9.75-4.366 9.75-9.75a9.74 9.74 0 0 0-4.032-7.9M24 .5C36.98.5 47.5 11.021 47.5 24S36.98 47.5 24 47.5S.5 36.98.5 24S11.021.5 24 .5m-4.909 34.25a4.91 4.91 0 1 1 9.818.001a4.91 4.91 0 0 1-9.818 0m-.5-21.5a5.41 5.41 0 1 0 10.818 0a5.41 5.41 0 0 0-10.818 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default yinYangSymbolRemix
